<template>
    <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25)" class="d-flex flex-column">
        <v-layout pa-3 class="titleCard" :style="{'background': barcolor}" style="flex: 0;">
            <v-flex shrink class="d-flex align-center">
                <v-icon large class="white--text mr-3">bar_chart</v-icon>
            </v-flex>
            <v-flex class="text-left" style="font-size: 20px">
                {{ title }}
            </v-flex>
        </v-layout>
        <v-layout justify-start py-3 px-5 style="background: #FF5100;flex: 0" v-show="maxregion">
            <v-flex shrink class="white--text text-left">
                <div style="font-size: 18px">{{ maxregion }}</div>
                <!-- TODO: Max count data -->
                <!--<div style="font-size: 28px">{{ max }} {{ unit }}</div>-->
            </v-flex>
        </v-layout>
        <v-layout pa-7 style="flex: 1">
            <v-flex>
                <div class="mb-3 text-left">{{ $t('general.unit') }}: {{ unit }}</div>
                <PieChart
                        :dataname="dataname"
                        :chartdata="chartdata"
                        :options="options"
                        :piecolor="piecolor"
                        :displayLabels="displayLabels"
                ></PieChart>
            </v-flex>
        </v-layout>

        <template v-if="referenceLink">
            <div class="text-left px-5 mb-5">
                {{ $t('general.reference') }}:
                <span @click="openLink(referenceLink)" class="txt-link">
                    <template v-if="referenceText">
                        <span>{{ referenceText }}</span>
                    </template>
                    <template v-else>
                        <span>{{ referenceLink }}</span>
                    </template>
                </span>
            </div>
        </template>
    </v-card>
</template>

<script>
    import PieChart from '@/components/PieChart'

    export default {
        name: "CardPieChart",
        components: {
            PieChart
        },
        props: ['title','chartdata','options','unit','dataname','piecolor','barcolor','max','maxregion', 'referenceText', 'referenceLink', 'displayLabels'],
        methods: {
            openLink(url) {
                if (url) {
                    if (url.split('.')[0] === 'www') {
                        window.open(`https://${url}`);
                    } else {
                        window.open(url);
                    }
                }
            }
        }
    }
</script>

<style scoped>

    .titleCard {
        color: #FFFFFF;
    }
    .titleCardGrey {
        background: #4F4F4F;
        color: #FFFFFF;
    }


</style>
